import {GridColDef} from '@material-ui/data-grid';
import {TFunction} from 'i18next';
import {createColDefWithDefaultConfiguration} from '../../shared/utils/dataGridDefaultColumnDefValues';
import {tableCellCurrencyFormatter, tableCellDateFormatter} from '../../shared/utils/tableCellValueFormatter';
import styles from './Payments.module.scss';
import {
  tableCellPaymentStatusClassNameFormatter,
  tableCellPaymentStatusFormatter,
  tableCellSourceOfFundsFormatter
} from './paymentsTableFormatters';
import CopyCellRender from '../shared/table/renders/copyCellRender/CopyCellRender';

export const paymentsTableColumnDefinitions =
  (t: TFunction): Array<GridColDef> => createColDefWithDefaultConfiguration(
    [
      {
        field: 'executedOn',
        headerName: t('PAYMENTS.EXECUTED'),
        valueFormatter: tableCellDateFormatter
      },
      {
        field: 'paymentIdSuffix',
        headerName: t('PAYMENTS.PAYMENT_ID'),
        renderCell: (params) => CopyCellRender(params, params.row.id)
      },
      {
        field: 'referenceNo',
        headerName: t('PAYMENTS.REFERENCE_NO'),
        cellClassName: styles.orderNo,
        renderCell: CopyCellRender
      },
      {
        field: 'createdOn',
        headerName: t('PAYMENTS.CREATED'),
        valueFormatter: tableCellDateFormatter
      },
      {
        field: 'sourceOfFund',
        headerName: t('PAYMENTS.SOURCE_OF_FUNDS'),
        valueFormatter: tableCellSourceOfFundsFormatter(t)
      },
      {
        field: 'paymentStatus',
        headerName: t('PAYMENTS.PAYMENT_STATUS'),
        valueFormatter: tableCellPaymentStatusFormatter(t),
        cellClassName: tableCellPaymentStatusClassNameFormatter
      },
      {
        field: 'amount',
        headerName: t('SHARED.AMOUNT'),
        valueFormatter: tableCellCurrencyFormatter
      }
    ]
  );
